import { render, staticRenderFns } from "./CPageIndexIndexStandard.vue?vue&type=template&id=be4e162a&"
import script from "./CPageIndexIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageIndexIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports